// Query keys for React Query caching
export const domainQueryKeys = {
  // Subject-related keys
  subjects: ['subjects'] as const,
  subjectsByDomain: (domainId: string) =>
    [...domainQueryKeys.subjects, 'by-domain', domainId] as const,
  subject: (subjectId: string) => [...domainQueryKeys.subjects, 'detail', subjectId] as const,

  // Institute admin-related keys
  instituteAdmins: ['institute-admins'] as const,
  instituteAdminsByDomain: (tenantId: string, domainId: string) =>
    [...domainQueryKeys.instituteAdmins, 'by-domain', tenantId, domainId] as const,

  // Domain info keys
  domainInfo: ['domain-info'] as const,
  domainById: (domainId: string) => [...domainQueryKeys.domainInfo, domainId] as const,

  // User existence check
  userExists: ['user-exists'] as const,
  userExistsByEmail: (email: string) => [...domainQueryKeys.userExists, email] as const,
};
